<script setup>
const props = defineProps({
	type: {
		type: String,
		default: 'short',
	},
	fill: {
		type: String,
		default: '#474747',
	},
})
</script>

<template>
	<svg width="752" height="22" viewBox="0 0 752 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type == 'short'">
		<path
			opacity="1"
			d="M1.17409 19.6686C5.87041 19.702 10.5668 19.7354 15.2617 19.8585C25.5128 20.1559 35.8045 21.6652 46.0081 21.1992C62.3998 20.4182 78.7629 17.6624 95.149 17.2404C114.539 16.7052 133.757 13.9247 153.332 14.8269C175.375 15.7915 197.627 12.8083 219.787 11.9786C248.609 10.8821 277.452 10.3692 306.273 9.36251C312.579 9.13809 318.873 7.74676 328.048 6.55542C329.256 7.19232 332.654 10.4477 336.161 10.4727C357.559 10.8493 378.972 10.2386 400.342 10.4804C419.453 10.6612 438.661 10.3939 457.596 12.3238C490.036 15.6511 522.332 16.7335 554.795 12.8356C566.53 11.4381 578.516 9.09991 590.125 10.0352C612.007 11.7616 633.605 6.88881 655.765 9.87378C683.828 13.6188 712.526 12.8356 740.995 13.442C744.502 13.5118 748.125 9.94733 751.662 8.04271C748.397 5.86531 745.247 1.98336 741.861 1.77977C726.386 0.951637 710.837 1.11029 695.32 1.0448C670.916 0.916091 646.492 0.20382 622.133 1.01788C579.958 2.42328 537.805 6.29715 495.68 6.40142C455.399 6.47393 415.164 1.65502 374.888 1.41341C319.006 1.10568 263.09 2.99675 207.188 4.03523C174.211 4.65335 141.262 5.4063 108.31 6.29388C78.4222 7.11349 48.5594 8.20257 18.6669 9.29143C14.0859 9.48323 9.47768 11.4251 4.99502 11.0342C4.41613 10.992 3.83203 10.9418 3.24723 10.8834C2.00649 10.7597 0.9085 11.7485 0.950293 12.9952C1.02488 15.2201 1.0993 17.4565 1.17409 19.6686Z"
			:fill="fill" />
	</svg>
</template>
